export default __webpack_public_path__ + "static/diplomats_Campaigner_ENFP_friendships-7a22139fff75bc361290de5f587e1e48.svg";